import React from "react";
import "./InputCustom.scss";
import { Form, Input, ConfigProvider } from "antd";

const InputCustom: React.FC<any> = (props) => {
    const { handleChange, rtl, value, hint, maxLength, headingleft, name, rules, className, headingright, labelleft, labelright, prefixSelector, placeholder } = props;
    const dir = rtl ? 'rtl' : 'ltr';
    const textAlign = rtl ? 'right' : 'left';
    return (
        <div className={`normal mb-3`}>
            <div className='inputField__error d-flex flex-column'>
                <div className="d-flex align-items-center">
                    <ConfigProvider>
                        <div className={`storybook__input ${className}`} style={{ float: textAlign }}>
                            <div className={'heading-section'}>
                                <div className='heading-left'>{headingleft !== '' ? headingleft : ''}</div>
                                <div className='heading-right'>{headingright !== '' ? headingright : ''}</div>
                            </div>
                            <div className={rtl ? "rtl" : "ltr"}>
                                <Form.Item
                                    rules={rules}
                                    name={name}
                                    hasFeedback
                                    className={prefixSelector ? "has-prefix-selector" : ""}
                                >
                                    <Input
                                        onChange={handleChange}
                                        type={"inactive"}
                                        maxLength={maxLength}
                                        width={325}
                                        value={value}
                                        className={`input-section`}
                                        {...(rtl
                                            ? { addonAfter: prefixSelector }
                                            : { addonBefore: prefixSelector }
                                        )}
                                        placeholder={placeholder}
                                        id={name}
                                    />
                                </Form.Item>
                            </div>
                            <div className={rtl ? 'helperText-section floatRtl' : 'helperText-section'}>
                                <div className='helperText-left'>{labelleft !== '' ? labelleft : ''}</div>
                                <div className='helperText-right'>{labelright !== '' ? labelright : ''}</div>
                            </div>
                        </div>
                    </ConfigProvider>
                    {hint ? <div className='hint-tooltip' data-tooltip={hint} /> : <div className="gap-18"></div>}
                </div>
            </div>
        </div>
    )
}

export default InputCustom;
